import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { PostClubProfilePenaltiesParams } from './request';
import { postClubProfilePenalties } from './request';

export const useClubProfilePenaltiesMutation = (
  settings?: MutationSettings<
    PostClubProfilePenaltiesParams,
    typeof postClubProfilePenalties
  >
) =>
  useMutation({
    mutationKey: ['ClubProfilePenalties'],
    mutationFn: ({ params, config }) =>
      postClubProfilePenalties({
        params,
        config
      }),
    ...settings?.options
  });
